import { useEffect, useState } from 'react'

/**
 * Tracks whether the viewport is narrower than `breakpoint` (default 1024px, the
 * Tailwind `lg` boundary). Used to swap the inline sidebar for an off-canvas
 * drawer on phones and tablets.
 */
export const useIsMobile = (breakpoint = 1024) => {
    const query = `(max-width: ${breakpoint - 1}px)`
    const [isMobile, setIsMobile] = useState(() =>
        typeof window !== 'undefined' ? window.matchMedia(query).matches : false
    )

    useEffect(() => {
        const mql = window.matchMedia(query)
        const onChange = (event) => setIsMobile(event.matches)
        mql.addEventListener('change', onChange)
        setIsMobile(mql.matches)
        return () => mql.removeEventListener('change', onChange)
    }, [query])

    return isMobile
}

export default useIsMobile
